module.exports = __webpack_public_path__ + "img/调研报告_04.6177a9f7.svg";